import moment from 'moment'
import { UseModel } from '../../api/Argentia/model/contracts'
import { UseModelPatch, UseModelRequest } from './uses.model'

export const mapUsesTable = (uses: UseModel[]): UseModel[] => {
  return uses.map(
    use => ({ ...use, percentage: use.percentage ? use.percentage * 100 : undefined }) as UseModel
  )
}

export const mapUseFormData = (use: UseModel): UseModel => {
  return { ...use, percentage: use.percentage ? use.percentage / 100 : undefined }
}

export const mapUsesRequest = (uses: UseModel[]): UseModelRequest[] => {
  return uses.map(use => mapUseRequest(use))
}

export const mapUseRequest = (use: UseModel): UseModelRequest => {
  return {
    ...use,
    startDate: moment(use.startDate).format('YYYY-MM-DD'),
    endDate: use.endDate ? moment(use.endDate).format('YYYY-MM-DD') : undefined
  }
}

export const mapUseRequestPatch = (use: Partial<UseModel>): UseModelPatch => {
  return {
    ...use,
    ...(use.startDate && { startDate: moment(use.startDate).format('YYYY-MM-DD') }),
    endDate: use.endDate ? moment(use.endDate).format('YYYY-MM-DD') : null
  }
}

export const mapPercentageSumOfAllUses = (rowData: UseModel[]): number => {
  return rowData.reduce((total, use) => total + (use.percentage || 0), 0)
}

export const mapPercentageSumOfOtherUses = (
  rowData: UseModel[],
  rowDataId?: number,
  rowDataTempId?: string
): number => {
  return rowData.reduce((total, use) => {
    if (rowDataId && use.id === rowDataId) {
      return total
    } else if (rowDataTempId && use.tempId === rowDataTempId) {
      return total
    }
    return total + (use.percentage || 0)
  }, 0)
}
